import CourseCatalogView from './CourseCatalogView';
import ErrorPanel from '../../shared/components/ErrorPanel';
import Grid from '@mui/material/Unstable_Grid2';
import LinearProgress from '@mui/material/LinearProgress';
import React from 'react';
import { SUPPORT_MESSAGE } from '../../shared/constants';
import Typography from '@mui/material/Typography';
import usePublicGroups from '../hooks/usePublicGroups';

const CourseCatalogContainer = () => {
  const {
    loading: groupsLoading,
    error: groupsError,
    publicGroups
  } = usePublicGroups();

  if (groupsLoading) {
    return (
      <Grid container direction="column">
        <Grid>
          <LinearProgress />
        </Grid>
        <Grid>
          <Typography variant="h5" align="center">
            Loading courses...
          </Typography>
        </Grid>
      </Grid>
    );
  }

  if (groupsError) {
    return (
      <ErrorPanel
        title="Whoops!"
        message="There was a problem with loading courses."
        details={SUPPORT_MESSAGE}
      />
    );
  }

  return (
    <>
      <CourseCatalogView groups={publicGroups} />
    </>
  );
};

export default CourseCatalogContainer;
